import React from 'react'
import { NavText } from '../../../../components/NavElements'
import classes from './EmployeeRightSide.module.css'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../State/Store'


export const EmployeeRightSide = ()=>{
    const user = useSelector((state: IRootState)=>state.user)
    
    return (
        <div className={classes.rightSide}>
            <div className={classes.companyInfo}>
                <img src={user.picture} alt={user.name} className={classes.companyImage}/>
                <p className={classes.companyName}>{user.name}</p>
            </div>
            <NavText to='/employee/home' activeStyle={{backgroundColor:"rgba(255,255,255,0.2)"}}>
            <div className={classes.Element}>
                <p>الرئيسية</p>
            </div>
            </NavText>

            <NavText to='/employee/status' activeStyle={{backgroundColor:"rgba(255,255,255,0.2)"}}>
            <div className={classes.Element}>
                <p>التقديمات</p>
            </div>
            </NavText>
            <NavText to='/employee/saved' activeStyle={{backgroundColor:"rgba(255,255,255,0.2)"}}>
                <div className={classes.Element}>
                    <p>المحفوظات</p>
                </div>
            </NavText>
            <NavText to='/employee/profile' activeStyle={{backgroundColor:"rgba(255,255,255,0.2)"}}>
                <div className={classes.Element}>
                    <p>الصفحة الشخصية</p>
                </div>
            </NavText>
            {/*<NavText to='/'>*/}
            {/*<div className={classes.Element}>*/}
            {/*    <p>بيانات حسابي</p>*/}
            {/*</div>*/}
            {/*</NavText>*/}
            <NavText to='/employee/complaint' activeStyle={{backgroundColor:"rgba(255,255,255,0.2)"}}>
            <div className={classes.Element}>
                <p>الإبلاغ عن مشكلة</p>
            </div>
            </NavText>
        </div>
    )
}